module.exports = __webpack_public_path__ + "img/feature-1-banner-mobile.92a9f5be.png";